<template>
  <div class="post-preview-container pa-4">
    <h3 class="text-h6 mb-4 mx-auto">Preview</h3>

    <!-- Platform Tabs -->
    <div class="platform-tabs-wrapper d-flex align-center justify-center mb-2">
      <v-slide-group
        v-model="selectedPlatform"
        class="platform-slide-group"
        show-arrows
        center-active
      >
        <v-slide-group-item
          v-for="(item, index) in platforms"
          :key="index"
          v-slot="{ isSelected }"
        >
          <div
            class="platform-tab"
            :class="[item.platform.toLowerCase(), { active: isSelected }]"
            @click="() => selectPlatform(index)"
          >
            <div class="platform-icon">
              <v-icon :icon="item.icon" size="16" />
            </div>
            <span class="platform-text">{{ item.type }}</span>
          </div>
        </v-slide-group-item>
      </v-slide-group>
    </div>

    <!-- Dynamic Preview Component -->
    <component :is="currentComponent" v-if="currentComponent" />
    <div v-else class="text-center pa-6">
      <div class="no-content">
        <div class="icon"><img :src="NoSliders" alt="no-sliders" /></div>
        <div class="title">See your content preview here</div>
        <div class="text">
          Select the type of content you'd like to post from each platform:
          Post, Story, Reel or all.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"; // ✅ ضيف onMounted
import apiClient from "@/core/buildRequest"; // ✅ عشان ننده الـ API
import { storeToRefs } from "pinia";
import { publishPost } from "@/store/publishPost/publishPost";

// Components
import Instgrampostreview from "./Newreviewcom/InstgramPostreviewcom.vue";
import Instgramstoryreview from "./Newreviewcom/InstgramStoryreviewcom.vue";
import InstgramReelReview from "./Newreviewcom/InstgramReelreviewcom.vue";
import FacebookAdPreview from "./Newreviewcom/FacebookAdPreview.vue";
import FacebookAdStory from "./Newreviewcom/FacebookAdStory.vue";
import FacebookAdReel from "./Newreviewcom/FacebookAdReel.vue";
import NoSliders from "@/assets/images/no-sliders.svg";
// Store
const store = publishPost();
const { selectedFacebookTypes, selectedInstgramTypes } = storeToRefs(store);

const selectedPlatform = ref(0);

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

onMounted(async () => {
  const postId = localStorage.getItem("postId");
  const editePostId = localStorage.getItem("editePostId");
  if (postId || editePostId) {
    const { data } = await apiClient.get("/get-scheduled-post", {
      params: { id: postId || editePostId },
    });

    const postData = data.data;

    // حدد المنصة والـ type
    const type = "post"; // ممكن تجيبه من الـ API لو بيحدده
    const typeObj = { id: type, label: capitalize(type) };

    if (postData.platform === "facebook") {
      selectedFacebookTypes.value = [typeObj];

      // احفظ الصورة والمحتوى في store.post.facebook
      store.post.facebook = [
        {
          file: {
            preview: postData.file,
            type: "image", // or "video" لو حابب تدعمه
          },
          caption: postData.caption,
        },
      ];
    }

    if (postData.platform === "instagram") {
      selectedInstgramTypes.value = [typeObj];

      store.post.instagram = [
        {
          file: {
            preview: postData.file,
            type: "image",
          },
          caption: postData.caption,
        },
      ];
    }
  }
});

const platforms = computed(() => {
  const result = [];

  selectedFacebookTypes.value.forEach((type) => {
  const label = typeof type === "string" ? type : type?.label || type?.id || "";
  result.push({
    platform: "Facebook",
    type: capitalize(label),
    icon: "mdi-facebook",
  });
});

  selectedInstgramTypes.value.forEach((type) => {
    const label = typeof type === "string" ? type : type?.label || type?.id || "";
    result.push({
      platform: "Instagram",
      type: capitalize(label),
      icon: "mdi-instagram",
    });
  });

  return result;
});

const selectPlatform = (index) => {
  selectedPlatform.value = index;
};

const currentComponent = computed(() => {
  const tab = platforms.value[selectedPlatform.value];
  if (!tab) return null;

  if (tab.platform === "Instagram" && tab.type === "Post")
    return Instgrampostreview;
  if (tab.platform === "Instagram" && tab.type === "Story")
    return Instgramstoryreview;
  if (tab.platform === "Instagram" && tab.type === "Reel")
    return InstgramReelReview;
  if (tab.platform === "Facebook" && tab.type === "Post")
    return FacebookAdPreview;
  if (tab.platform === "Facebook" && tab.type === "Story")
    return FacebookAdStory;
  if (tab.platform === "Facebook" && tab.type === "Reel") return FacebookAdReel;

  return null;
});
</script>

<style scoped>
.post-preview-container {
  max-width: 500px;
  margin: auto;
}

.platform-slide-group {
  width: 100%;
  min-height: 5rem;
}
.platform-tab {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background-color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  margin: 0 6px;
  transition: border 0.3s;
  border: 2px solid #ccc;
}

.platform-tab .platform-icon {
  position: absolute;
  top: -0.5rem;
  left: -0.3rem;
  background-color: #444;
  border-radius: 50%;
  padding: 4px;
  width: 1.4rem;
  height: 1.4rem;
  color: white;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Platform-specific base color */
.platform-tab.facebook .platform-icon {
  background-color: #444;
}
.platform-tab.instagram .platform-icon {
  background-color: #444;
}

/* Active border and icon colors */
.platform-tab.facebook.active {
  border: 2px solid #1877f2;
}
.platform-tab.facebook.active .platform-icon {
  background-color: #1877f2;
}

.platform-tab.instagram.active {
  border: 2px solid #e1306c;
}
.platform-tab.instagram.active .platform-icon {
  background-color: #e1306c;
}

.platform-text {
  z-index: 1;
}
</style>
